import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const LogoutIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g strokeLinecap="round" strokeLinejoin="round">
      <path d="M16.313 8.063 20.25 12l-3.938 3.938M9.75 12h10.5M9.75 20.25H4.5a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 .75-.75h5.25" />
    </g>
  </svg>);
export default LogoutIcon;